import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import * as styles from "./legal.module.css"
import useLinksTo from "../hooks/use-links-to"
import { testIds } from "../common/constants"

const Legal = () => {
  const data = useStaticQuery(graphql`
    query {
      contentfulConfig(title: { eq: "W3" }) {
        copyright
        policies {
          id
          title
          slug
        }
      }
    }
  `)

  const config = data.contentfulConfig
  const { getPageTo } = useLinksTo()
  const { legal } = testIds.global.footer

  return (
    <div className={styles.wrapper}>
      <div data-cy={legal.copyright} className="has-text-grey-light mb-4">
        {config.copyright}
      </div>
      <nav className="columns">
        {config.policies.map(policy => (
          <Link
            data-cy={legal.link}
            key={policy.id}
            to={getPageTo(policy.slug)}
            className={`${styles.link} column`}
          >
            {policy.title}
          </Link>
        ))}
      </nav>
    </div>
  )
}

export default Legal
